import * as React from 'react';
import './HowToInvest.css';
import { Link } from 'react-router-dom';

interface Props {
  register: () => void;
  isLogged?: boolean;
}

const TransparentFeesSectionComponent: React.StatelessComponent<Props> = (props: Props) => (
  <div className="container">
    <div className="gap-40"/>
    <h3 style={{fontSize: '22px'}}>
      <strong>Comisiones transparentes y alineadas con los objetivos del inversor</strong>
    </h3>
    Para alinear nuestros objetivos con los tuyos, cobramos una pequeña comisión de gestión en el momento de la
    inversión, pero el beneficio real llegará si tú también ganas.

    <div className="gap-30"/>
    <div className="transparent-fees row flex-container">
      <div className="col-md-4 col-sm-12">
        <div
          className="simple-card-green"
          style={{height: '100%', width: '100%', padding: '15px 15px'}}
        >
          <div className="gap-40"/>
          <div className="gap-5"/>
          <div className="row title-card-green">
            Comisión de corretaje
          </div>
          <div className="gap-50"/>
          <div className="gap-50"/>
          <div className="row fee-number">
            2<a className="x">%</a>
          </div>
          <div className="gap-30"/>
          <div className="gap-20"/>
          <div className="row fee-description">
            Del capital invertido
          </div>
          <div className="row fee-description">
            (IVA no incluido)
          </div>
          <div className="gap-30"/>
          <div className="row fee-description2">
            Se factura en el momento de la inversión
          </div>
          <div className="row fee-description2">
            y se incluye en el pago de la operación
          </div>

        </div>
      </div>

      <div className="col-md-4 col-sm-12">
        <div
          className="simple-card-green"
          style={{height: '100%', width: '100%', padding: '15px 15px'}}
        >
          <div className="gap-40"/>
          <div className="gap-5"/>
          <div className="row title-card-green">
            Carried interest
          </div>
          <div className="gap-50"/>
          <div className="gap-50"/>
          <div className="row fee-number">
            10<a className="x">%</a>
          </div>
          <div className="gap-30"/>
          <div className="gap-20"/>
          <div className="row fee-description">
            De las plusvalías obtenidas
          </div>
          <div className="row fee-description">
            en la inversión
          </div>
          <div className="gap-30"/>
          <div className="row fee-description2">
            Se factura en el momento de la desinversión
          </div>

        </div>
      </div>

      <div className="col-md-4 col-sm-12">
        <div
          className="simple-card-green"
          style={{height: '100%', width: '100%', padding: '15px 15px'}}
        >
          <div className="gap-20"/>
          <div className="gap-5"/>
          <div className="row costes-green">
            Estos costes incluyen
          </div>
          <div className="gap-10"/>
          <div className="row costes-description padding-20">
            Acceso a operaciones previamente seleccionadas y analizadas.
            <br/>
            <div className="gap-5"/>
            Disponibilidad de un canal de comunicación con el emprendedor y el resto de inversores.
            <br/>
            <div className="gap-5"/>
            Posibilidad de coinvertir con algunos de los mejores VCs de España.
            <br/>
            <div className="gap-5"/>
            Transferencia segura con plataforma de pagos.
            <br/>
            <div className="gap-5"/>
            Pacto de socios y contrato de Sindicación con los estándares del capital riesgo.
            <br/>
            <div className="gap-5"/>
            Informes de seguimiento trimestrales.
            <br/>
            <div className="gap-5"/>
            Acompañamiento del equipo The Crowd Angel desde la inversión hasta la desinversión.
          </div>

        </div>
      </div>

    </div>

    <div className="gap-20"/>
    <p className="text-center">
      {props.isLogged ?
        <Link to={'/invertir'}>
          <button className="btn btn-secondary btn-lg">
            Invertir
          </button>
        </Link> :
        <button
          className="btn btn-secondary btn-lg"
          onClick={() => props.register()}
        >
          Registrarse
        </button>
      }
    </p>

  </div>
);

export default TransparentFeesSectionComponent;


// WEBPACK FOOTER //
// ./src/modules/how-to-invest/partials/TransparentFeesSection.component.tsx